export const HOURLY_METRICS_STORAGE_KEY = "ba-campaign-card-hourly-metrics";

export const readHourlyMetricsSelection = <K extends string>(
	defaults: Record<K, boolean>,
): Record<K, boolean> => {
	const selection = { ...defaults };
	try {
		const raw = localStorage.getItem(HOURLY_METRICS_STORAGE_KEY);
		if (!raw) return selection;
		const parsed: unknown = JSON.parse(raw);
		if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
			return selection;
		}
		const stored = parsed as Record<string, unknown>;
		(Object.keys(defaults) as K[]).forEach((key) => {
			const value = stored[key];
			if (typeof value === "boolean") selection[key] = value;
		});
		return selection;
	} catch {
		return selection;
	}
};

export const saveHourlyMetricsSelection = (
	selection: Record<string, boolean>,
): void => {
	try {
		localStorage.setItem(HOURLY_METRICS_STORAGE_KEY, JSON.stringify(selection));
	} catch {}
};
